module.exports = __webpack_public_path__ + "img/inactive-20.6c100362.svg";